import React from 'react';

import { Loader2 } from 'lucide-react';
import { type VariantProps, tv } from 'tailwind-variants';

const spinnerVariants = tv({
  base: 'animate-spin',
  variants: {
    size: {
      small: 'size-3',
      default: 'size-4',
      large: 'size-5',
      xlarge: 'size-6',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

type SpinnerProps = VariantProps<typeof spinnerVariants>;

const SpinnerV2 = ({ size }: SpinnerProps) => {
  return <Loader2 className={spinnerVariants({ size })} />;
};

export default SpinnerV2;
